/* Suave Forma · venta cruzada v2 + regalo a elegir (30 oct)
   - Página de producto: el cuadro de $299 abre una vista rápida (fotos, color, talla, guía) y la casilla solo agrega.
   - Carrito: si llevas medias y no el brasier (o al revés), ofrece el producto de $299 con la misma vista rápida.
   - Carrito: con 2 medias pagadas ofrece 1 prenda GRATIS y con 3, 2 prendas (otra media o un brasier, como quiera).
     Se agregan con la propiedad _regalo para distinguirlas de las pagadas. El precio $0 lo hacen los descuentos
     automáticos «Medias: paga 2 y lleva 3» y «Medias: paga 3 y lleva 5» (compra X lleva Y, sin importar la propiedad).
   - Botones [data-sf-add="variantId:cantidad"] en el carrito (mejora de pack) agregan sin salir del carrito. */
(function () {
  if (window.__sfx) return; window.__sfx = true;
  var C = window.SFX_CONFIG; if (!C) return;
  var cache = {}, modal, state = {};

  function money(c) { return '$' + (c / 100).toLocaleString('es-MX', { maximumFractionDigits: 0 }); }
  function get(h) { return cache[h] || (cache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.json(); })); }
  function offerByClone(h) { for (var i = 0; i < C.offers.length; i++) if (C.offers[i].clone === h) return C.offers[i]; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src, w) { return src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2'); }

  /* ---------- vista rápida ---------- */
  function build() {
    modal = document.createElement('div');
    modal.id = 'sfx'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    modal.innerHTML = '<div class="sfx-bx"><button class="sfx-x" type="button" aria-label="Cerrar">&times;</button><div class="sfx-in"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('.sfx-x')) close(); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') close(); });
  }
  function close() { if (modal) { modal.classList.remove('on'); document.documentElement.classList.remove('sfx-lock'); } }

  function open(o, onAdd, preset) {
    if (!modal) build();
    var inner = modal.querySelector('.sfx-in');
    inner.innerHTML = '<div class="sfx-load">Cargando…</div>';
    modal.classList.add('on'); document.documentElement.classList.add('sfx-lock');
    Promise.all([get(o.clone), get(o.full)]).then(function (r) {
      var cl = r[0], full = r[1];
      var byColor = {};
      full.variants.forEach(function (v) { if (v.featured_image && !byColor[v.option1]) byColor[v.option1] = v.featured_image.src; });
      var pics = full.images.filter(function (s) { return !o.gallery || o.gallery.some(function (k) { return s.indexOf(k) > -1; }); });
      if (!pics.length) pics = full.images.slice(0, 6);
      var o1 = cl.options[0], o2 = cl.options[1];
      state = { o: o, cl: cl, c: (preset && preset[0]) || '', t: (preset && preset[1]) || '', onAdd: onAdd };
      var sw = o1.values.map(function (v, i) {
        return '<button type="button" class="sfx-sw" data-v="' + esc(v) + '" style="--c:' + ((o.swatches && o.swatches[i]) || '#ccc') + '"><i></i><span>' + esc(v) + '</span></button>';
      }).join('');
      var sz = o2.values.map(function (v) { return '<button type="button" class="sfx-sz" data-v="' + esc(v) + '">' + esc(v) + '</button>'; }).join('');
      var guide = '';
      if (o.size) {
        var rows = o.size.rows.map(function (r) { return '<tr>' + r.map(function (c) { return '<td>' + esc(c) + '</td>'; }).join('') + '</tr>'; }).join('');
        guide = '<div class="sfx-guide"><table><thead><tr>' + o.size.head.map(function (h) { return '<th>' + esc(h) + '</th>'; }).join('') + '</tr></thead><tbody>' + rows + '</tbody></table><p>' + o.size.note + '</p></div>';
      }
      var price = o.free
        ? '<p class="sfx-pr"><b>GRATIS</b> <s>' + money(full.price) + '</s> <em>' + (o.freeLine || 'Tu regalo') + '</em></p>'
        : '<p class="sfx-pr"><b>' + money(cl.price) + '</b> <s>' + money(cl.compare_at_price) + '</s> <em>Ahorras ' + money(cl.compare_at_price - cl.price) + '</em></p>';
      var ready = o.free ? 'Agregar mi regalo · GRATIS' : 'Agregar a mi pedido · ' + money(cl.price);
      inner.innerHTML =
        '<div class="sfx-gal"><div class="sfx-main"><img alt="' + esc(o.name) + '" src="' + img(pics[0], 900) + '"><span class="sfx-tag">' + o.tag + '</span></div>' +
        '<div class="sfx-th">' + pics.map(function (s, i) { return '<button type="button" data-src="' + s + '"' + (i ? '' : ' class="on"') + '><img alt="" loading="lazy" src="' + img(s, 160) + '"></button>'; }).join('') + '</div></div>' +
        '<div class="sfx-info"><p class="sfx-k">' + o.kicker + '</p><h3>' + esc(o.name) + '</h3>' + price +
        '<ul class="sfx-ul">' + (o.bullets || []).map(function (b) { return '<li>' + b + '</li>'; }).join('') + '</ul>' +
        '<p class="sfx-lb">' + esc(o1.name) + ': <span data-l="c">Elige uno</span></p><div class="sfx-sws">' + sw + '</div>' +
        '<p class="sfx-lb">' + esc(o2.name) + ': <span data-l="t">Elige tu talla</span>' + (o.size ? ' <button type="button" class="sfx-gd">¿Qué talla soy?</button>' : '') + '</p><div class="sfx-szs">' + sz + '</div>' +
        guide +
        '<button type="button" class="sfx-add" disabled>Elige color y talla</button>' +
        '<p class="sfx-note">' + o.note + '</p>' +
        '<a class="sfx-more" href="/products/' + o.full + '" target="_blank" rel="noopener">Ver todos los detalles del producto ›</a></div>';
      var main = inner.querySelector('.sfx-main img');
      inner.querySelectorAll('.sfx-th button').forEach(function (b) {
        b.addEventListener('click', function () { main.src = img(b.dataset.src, 900); inner.querySelectorAll('.sfx-th button').forEach(function (x) { x.classList.toggle('on', x === b); }); });
      });
      function pick(kind, v) {
        state[kind] = v;
        inner.querySelectorAll(kind === 'c' ? '.sfx-sw' : '.sfx-sz').forEach(function (b) { b.classList.toggle('on', b.dataset.v === v); });
        inner.querySelector('[data-l="' + kind + '"]').textContent = v;
        if (kind === 'c' && byColor[v]) main.src = img(byColor[v], 900);
        var add = inner.querySelector('.sfx-add'), ok = state.c && state.t;
        add.disabled = !ok;
        add.textContent = ok ? ready : (state.c ? 'Elige tu talla' : 'Elige color y talla');
      }
      inner.querySelectorAll('.sfx-sw').forEach(function (b) { b.addEventListener('click', function () { pick('c', b.dataset.v); }); });
      inner.querySelectorAll('.sfx-sz').forEach(function (b) { b.addEventListener('click', function () { pick('t', b.dataset.v); }); });
      var gd = inner.querySelector('.sfx-gd');
      if (gd) gd.addEventListener('click', function () { inner.querySelector('.sfx-guide').classList.toggle('on'); });
      if (state.c) pick('c', state.c); if (state.t) pick('t', state.t);
      inner.querySelector('.sfx-add').addEventListener('click', function () {
        var v = cl.variants.filter(function (x) { return x.option1 === state.c && x.option2 === state.t; })[0];
        if (!v) return;
        if (!v.available) { this.textContent = 'Agotado en esa talla, elige otra'; return; }
        var btn = this; btn.disabled = true; btn.textContent = 'Agregando…';
        Promise.resolve(state.onAdd(v, state.c, state.t)).then(function () { close(); }, function () { btn.disabled = false; btn.textContent = 'Intenta de nuevo'; });
      });
    }, function () { inner.innerHTML = '<div class="sfx-load">No se pudo cargar. Intenta de nuevo.</div>'; });
  }

  /* ---------- página de producto: cuadro de venta cruzada ---------- */
  function enhancePdp() {
    document.querySelectorAll('product-info-upsell[data-handle]').forEach(function (u) {
      var o = offerByClone(u.dataset.handle);
      if (!o || u.dataset.sfx) return;
      u.dataset.sfx = '1'; u.classList.add('sfx-up');
      var box = u.closest('.product-info-upsells-container'); if (box) box.classList.add('sfx-box');
      var content = u.querySelector('.upsell__content');
      var chip = document.createElement('button');
      chip.type = 'button'; chip.className = 'sfx-chip'; chip.innerHTML = 'Ver fotos y elegir talla <span>›</span>';
      content.appendChild(chip);
      function show(e) {
        e.preventDefault(); e.stopPropagation();
        var sel = u.querySelectorAll('select');
        open(o, function (v, c, t) {
          if (sel[0]) { sel[0].value = c; sel[0].dispatchEvent(new Event('change', { bubbles: true })); }
          if (sel[1]) { sel[1].value = t; sel[1].dispatchEvent(new Event('change', { bubbles: true })); }
          u.dataset.sfxChosen = c + ' · ' + t;
          chip.innerHTML = '<b>✓ ' + esc(c) + ' · Talla ' + esc(t) + '</b> <span>Cambiar</span>';
          if (u.dataset.selected !== 'true') { var tg = u.querySelector('.upsell-toggle-btn'); u.__sfxPass = true; tg && tg.click(); u.__sfxPass = false; }
          toast(o.short + ' agregado a tu pedido');
        }, u.dataset.sfxChosen ? u.dataset.sfxChosen.split(' · ') : null);
      }
      [u.querySelector('.upsell__image'), u.querySelector('.upsell__title h3'), chip].forEach(function (el) { el && el.addEventListener('click', show); });
      /* la casilla: si aún no eligió talla, primero abre la vista rápida */
      u.addEventListener('click', function (e) {
        var tg = e.target.closest('.upsell-toggle-btn');
        if (!tg || u.__sfxPass) return;
        if (u.dataset.selected !== 'true' && !u.dataset.sfxChosen) show(e);
      }, true);
    });
  }

  function toast(t) {
    var el = document.createElement('div'); el.className = 'sfx-toast'; el.textContent = '✓ ' + t;
    document.body.appendChild(el); setTimeout(function () { el.classList.add('on'); }, 20);
    setTimeout(function () { el.classList.remove('on'); setTimeout(function () { el.remove(); }, 400); }, 2600);
  }

  /* ---------- carrito ---------- */
  var busy = false, last = '';
  function place(host, card) {
    var items = host.querySelector('cart-drawer-items');
    var footer = host.querySelector('.drawer__footer');
    if (items && items.nextSibling) items.parentNode.insertBefore(card, items.nextSibling);
    else if (footer) footer.parentNode.insertBefore(card, footer); else host.appendChild(card);
  }
  /* prendas gratis pendientes (1 con 2 medias, 2 con 3): la clienta elige media o brasier */
  function giftCard(drawer, host, g, lastMedia, left) {
    Promise.all(g.items.map(function (x) { return get(x.full); })).then(function (ps) {
      if (drawer.querySelector('.sfx-cart')) return;
      var card = document.createElement('div');
      card.className = 'sfx-cart sfx-gift';
      var kicker = left > 1 ? '🎁 Tienes 2 prendas GRATIS' : '🎁 Te falta 1 prenda GRATIS';
      var line = left > 1 ? 'Elige la primera: otra media o un brasier (luego eliges la segunda).' : 'Elígela: otra media o un brasier.';
      card.innerHTML = '<p class="sfx-ck">' + kicker + '</p><p class="sfx-gl">' + line + '</p><div class="sfx-gs">' +
        g.items.map(function (x, i) {
          return '<button type="button" data-i="' + i + '"><img alt="" src="' + img(x.cartImg || ps[i].featured_image, 200) + '"><b>' + esc(x.short) + '</b><span>GRATIS <s>' + money(ps[i].price) + '</s></span></button>';
        }).join('') + '</div>';
      place(host, card);
      card.querySelectorAll('button[data-i]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var x = g.items[+b.dataset.i];
          var preset = (x.full === lastMedia.handle && lastMedia.c) ? [lastMedia.c, lastMedia.t] : null;
          open(x, function (v) { return addToCart(v.id, 1, { _regalo: '1' }); }, preset);
        });
      });
    });
  }
  function cartOffer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || busy) return;
    var host = drawer.querySelector('.drawer__contents, .drawer__inner') || drawer;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      busy = false;
      var types = {}, handles = {}, paid = 0, free = 0, lastMedia = {};
      cart.items.forEach(function (i) {
        handles[i.handle] = 1;
        if (i.properties && i.properties._regalo) { free += i.quantity; return; }
        types[i.product_type] = 1;   /* un brasier de regalo no dispara la oferta de medias a $299 */
        if (i.product_type === 'Medias térmicas') {
          paid += i.quantity;
          var op = i.options_with_values || [];
          lastMedia = { handle: i.handle, c: op[0] && op[0].value, t: op[1] && op[1].value };
        }
      });
      /* 2 medias pagadas = 1 prenda gratis · 3 o más = 2 prendas gratis */
      var left = (paid >= 3 ? 2 : paid === 2 ? 1 : 0) - free;
      var g = C.gift && left > 0 ? C.gift : null;
      var o = g ? null : C.offers.filter(function (x) { return types[x.needs] && !handles[x.clone] && !handles[x.full]; })[0];
      var old = drawer.querySelector('.sfx-cart');
      var key = (g ? 'gift' + left : (o ? o.clone : '')) + cart.item_count;
      if (old && key === last && old.isConnected) return;
      last = key; if (old) old.remove();
      if (g) return giftCard(drawer, host, g, lastMedia, left);
      if (!o) return;
      get(o.clone).then(function (cl) {
        if (drawer.querySelector('.sfx-cart')) return;
        var card = document.createElement('div');
        card.className = 'sfx-cart';
        card.innerHTML = '<p class="sfx-ck">' + o.cartKicker + '</p><div class="sfx-cr"><img alt="" src="' + img(o.cartImg || cl.featured_image, 200) + '">' +
          '<div><b>' + esc(o.name) + '</b><span><strong>' + money(cl.price) + '</strong> <s>' + money(cl.compare_at_price) + '</s></span><small>' + o.cartLine + '</small></div>' +
          '<button type="button">Agregar</button></div>';
        place(host, card);
        card.addEventListener('click', function (e) {
          e.preventDefault();
          open(o, function (v) { return addToCart(v.id, 1); });
        });
      });
    }, function () { busy = false; });
  }
  function addToCart(id, qty, props) {
    var drawer = document.querySelector('cart-drawer');
    var secs = (drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble']);
    var item = { id: id, quantity: qty || 1 };
    if (props) item.properties = props;
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item], sections: secs.join(','), sections_url: location.pathname }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (res) {
        last = '';
        try { drawer.renderContents(res); } catch (e) { location.reload(); }
        toast('Agregado a tu carrito');
      });
  }
  /* mejora de pack desde la barra del carrito (cart-checkpoints-bar.liquid) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sf-add]');
    if (!b) return;
    e.preventDefault();
    var p = b.dataset.sfAdd.split(':');
    b.disabled = true; b.textContent = 'Agregando…';
    addToCart(+p[0], +p[1] || 1).catch(function () { b.disabled = false; b.textContent = 'Intenta de nuevo'; });
  });

  var t;
  function tick() { clearTimeout(t); t = setTimeout(function () { enhancePdp(); cartOffer(); }, 250); }
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) { var n = m[i].target; if (n.closest && (n.closest('cart-drawer') || n.closest('product-info'))) { tick(); return; } }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
})();
